export const links = {
  docs: {
    config: {
      home: "https://trigger.dev/docs/config/config-file",
      additionalPackages: "https://trigger.dev/docs/config/config-file#additionalpackages",
      extensions: "https://trigger.dev/docs/config/config-file#extensions",
      prisma: "https://trigger.dev/docs/config/config-file#prisma",
    },
    machines: {
      home: "https://trigger.dev/docs/v3/machines",
    },
    upgrade: {
      beta: "https://trigger.dev/docs/upgrading-beta",
    },
    troubleshooting: {
      concurrentWaits: "https://trigger.dev/docs/troubleshooting#parallel-waits-are-not-supported",
      stalledExecution: "https://trigger.dev/docs/troubleshooting#task-run-stalled-executing",
      uncaughtException: "https://trigger.dev/docs/troubleshooting#uncaught-exceptions",
    },
    concurrency: {
      recursiveDeadlock:
        "https://trigger.dev/docs/queue-concurrency#waiting-for-a-subtask-on-the-same-queue",
      deadlock: "https://trigger.dev/docs/queue-concurrency#deadlock",
    },
    gitHubActions: {
      personalAccessToken:
        "https://trigger.dev/docs/github-actions#creating-a-personal-access-token",
    },
  },
  site: {
    home: "https://trigger.dev",
    contact: "https://trigger.dev/contact",
  },
};
